<template>
	<div class="card">
		<div class="card-header">
			<h3 class="page-title">
				<i class="far fa-sticky-note"></i> Inspection Report
			</h3>
		</div>
		<div class="card-body">
			<form @submit.prevent="saveReport">
				<div class="form-group">
					<vue-editor v-model="f.insp_report" :editor-toolbar="customToolbar"></vue-editor>
				</div>
				<div class="row">
					<div class="col-12 text-right">
						<button type="submit" class="btn btn-success">
							<i class="fas fa-save"></i> SAVE
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
import { VueEditor } from 'vue2-editor'
export default {
	name: 'inspReportSales',
	components: {
		VueEditor
	},
	data () {
		return {
			f: {
				user_id: window.master_client,
                org_id: window.localorgdata,
				idSale: 0,
				id: 0,
				points: 0,
				insp_report: '',
			},
            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                // ["link", "image", "video"],
                ["link"],
                ["clean"] // remove formatting button
            ],
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let t = this;
			let d = t.$store.getters['core/getOpenModal'].data;
			t.f.sales_id= d.id;
			t.f.insp_report=d.insp_report
            t.$store.commit("core/setLoadingModal", false);
		},
		saveReport(){
			let t = this;
			t.$store.commit("core/setLoadingModal", true);
			window.master.post('setInspReportSales', t.f)
            .then((response) => {
                console.log('setInspReportSales', response.data);
                t.$notify({
                    group: "noti",
                    type: "success",
                    title: "Successfully saved",
                    text: " Report registered",
                });
                t.$store.commit("core/setLoadingModal", false);
                this.$parent.$emit('closed-lateral');
            })
            .catch((error) => {
            	console.log(error);
            	t.$store.commit("core/setLoadingModal", false);
            });
		}
	}
}
</script>
<style lang="css" scoped>
.ql-editor {
    max-height: 400px;
    overflow-y: auto;
}
</style>
